import { render, staticRenderFns } from "./favorite-empty-msg.vue?vue&type=template&id=11497a64"
import script from "./favorite-empty-msg.vue?vue&type=script&lang=js"
export * from "./favorite-empty-msg.vue?vue&type=script&lang=js"
import style0 from "./favorite-empty-msg.vue?vue&type=style&index=0&id=11497a64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports